module.exports = __webpack_public_path__ + "img/logoFunEatsNegro.cf17a03f.svg";